module.exports = __webpack_public_path__ + "img/midfi-2.038da5dc.png";